const DEFAULT_FLOW_COLOR = 'grey';
const DEFAULT_LOG_COLOR = '#6b7280';
const DEFAULT_ICON = 'mdi-circle';
const DEFAULT_LOG_GRADIENT = 'linear-gradient(135deg, #6b7280 0%, #4b5563 100%)';

export const JSON_CONDITION_OPERATOR_TOKENS = Object.freeze({
	equals: '=',
	not_equals: '≠',
	greater_than: '>',
	less_than: '<',
	greater_equal: '≥',
	less_equal: '≤',
	contains: '⊃',
	not_contains: '⊅',
	starts_with: 'starts',
	ends_with: 'ends',
	regex: '~ regex',
	is_empty: 'empty',
	is_not_empty: '≠ empty',
	exists: '∃',
	not_exists: '∄',
	array_empty: '[] empty',
	array_not_empty: '[] ≠ empty',
	array_contains: '[] ⊃',
	array_length_min: 'len ≥',
	array_length_max: 'len ≤',
	array_length_equals: 'len =',
	array_all_unique: 'all unique',
	is_true: 'true',
	is_false: 'false',
	type_is: 'type:',
	one_of: '∈',
	not_one_of: '∉',
	format: 'fmt:',
	equals_field: '= field',
	greater_than_field: '> field',
	less_than_field: '< field',
});

export const NODE_TYPE_INFO = Object.freeze({
	messageInput: Object.freeze({
		flowLabel: 'Message Input',
		logLabel: 'Message Input',
		workflowLabel: 'Message Input',
		flowIcon: 'mdi-chat',
		logIcon: 'mdi-message-text',
		flowColor: 'green',
		logColor: '#22c55e',
	}),
	webhookTrigger: Object.freeze({
		flowLabel: 'Webhook Trigger',
		logLabel: 'Webhook Trigger',
		workflowLabel: 'Webhook Trigger',
		flowIcon: 'mdi-webhook',
		logIcon: 'mdi-webhook',
		flowColor: 'purple',
		logColor: '#a855f7',
		logGradient: 'linear-gradient(135deg, #a855f7 0%, #9333ea 100%)',
	}),
	model: Object.freeze({
		flowLabel: 'AI Model',
		logLabel: 'AI Model',
		workflowLabel: 'AI Model',
		flowIcon: 'mdi-robot',
		logIcon: 'mdi-robot',
		flowColor: 'blue',
		logColor: '#3b82f6',
		logGradient: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
	}),
	aiModel: Object.freeze({
		logLabel: 'AI Model Processing',
		workflowLabel: 'AI Model',
		logIcon: 'mdi-robot',
		logColor: '#3b82f6',
	}),
	guardrailAI: Object.freeze({
		flowLabel: 'Guardrail AI',
		workflowLabel: 'Guardrail AI',
		flowIcon: 'mdi-shield-check',
		flowColor: 'green',
	}),
	intentAI: Object.freeze({
		flowLabel: 'Intent AI Model',
		workflowLabel: 'Intent AI Model',
		flowIcon: 'mdi-target-variant',
		flowColor: 'purple',
	}),
	intentClassifier: Object.freeze({
		flowLabel: 'Intent Classifier',
		workflowLabel: 'Intent Classifier',
		flowIcon: 'mdi-sort-variant',
		flowColor: 'purple',
	}),
	intent: Object.freeze({
		flowLabel: 'Intent',
		logLabel: 'Intent Router',
		workflowLabel: 'Intent',
		flowIcon: 'mdi-crosshairs-question',
		logIcon: 'mdi-router',
		flowColor: 'purple',
		logColor: '#8b5cf6',
		logGradient: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
	}),
	smartIntent: Object.freeze({
		flowLabel: 'Smart Intent',
		logLabel: 'Smart Intent',
		workflowLabel: 'Smart Intent',
		flowIcon: 'mdi-robot-confused',
		logIcon: 'mdi-robot-confused',
		flowColor: 'purple',
		logColor: '#4f46e5',
		logGradient: 'linear-gradient(135deg, #4f46e5 0%, #6366f1 100%)',
	}),
	advancedRouter: Object.freeze({
		flowLabel: 'Advanced Router',
		logLabel: 'Advanced Router',
		workflowLabel: 'Advanced Router',
		flowIcon: 'mdi-source-branch',
		logIcon: 'mdi-source-branch',
		flowColor: 'purple',
		logColor: '#8b5cf6',
		logGradient: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
	}),
	jsonCondition: Object.freeze({
		label: 'JSON Condition',
		icon: 'mdi-code-json',
		color: 'indigo',
		flowLabel: 'JSON Condition',
		logLabel: 'JSON Condition',
		workflowLabel: 'JSON Condition',
		flowIcon: 'mdi-code-json',
		logIcon: 'mdi-code-json',
		flowColor: 'teal',
		logColor: '#06b6d4',
		logGradient: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)',
	}),
	apiTrigger: Object.freeze({
		flowLabel: 'API Trigger',
		logLabel: 'API Trigger',
		workflowLabel: 'API Trigger',
		flowIcon: 'mdi-rocket-launch',
		logIcon: 'mdi-rocket-launch',
		flowColor: 'blue',
		logColor: '#0ea5e9',
		logGradient: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)',
	}),
	contactAgent: Object.freeze({
		flowLabel: 'Contact Agent',
		logLabel: 'Contact Agent',
		workflowLabel: 'Contact Agent',
		flowIcon: 'mdi-account-supervisor',
		logIcon: 'mdi-account-supervisor',
		flowColor: 'red',
		logColor: '#dc2626',
		logGradient: 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)',
	}),
	switch: Object.freeze({
		flowLabel: 'Switch',
		workflowLabel: 'Switch',
		flowIcon: 'mdi-arrow-decision',
		flowColor: 'red',
	}),
	condition: Object.freeze({
		flowLabel: 'Condition',
		workflowLabel: 'Condition',
		flowIcon: 'mdi-swap-horizontal-bold',
		flowColor: 'green',
	}),
	delay: Object.freeze({
		flowLabel: 'Delay',
		workflowLabel: 'Delay',
		flowIcon: 'mdi-timer',
		flowColor: 'blue',
	}),
	documents: Object.freeze({
		flowLabel: 'Documents',
		logLabel: 'Documents',
		workflowLabel: 'Documents',
		flowIcon: 'mdi-file-document-multiple',
		logIcon: 'mdi-file-document-multiple',
		flowColor: 'blue',
		logColor: '#0369a1',
		logGradient: 'linear-gradient(135deg, #0369a1 0%, #075985 100%)',
	}),
	api: Object.freeze({
		flowLabel: 'API Call',
		workflowLabel: 'API Call',
		flowIcon: 'mdi-api',
		flowColor: 'amber',
	}),
	response: Object.freeze({
		flowLabel: 'Response',
		logLabel: 'Message Output',
		workflowLabel: 'Response',
		flowIcon: 'mdi-message-reply-text',
		logIcon: 'mdi-message-reply-text',
		flowColor: 'red',
		logColor: '#f97316',
	}),
	databaseIntegration: Object.freeze({
		flowLabel: 'Database Integration',
		logLabel: 'DB Integration',
		workflowLabel: 'Database Integration',
		flowIcon: 'mdi-database-search',
		logIcon: 'mdi-database-search',
		flowColor: 'green',
		logColor: '#16a34a',
		logGradient: 'linear-gradient(135deg, #16a34a 0%, #15803d 100%)',
	}),
	apiknowledge: Object.freeze({
		flowLabel: 'Knowledge API',
		logLabel: 'API Knowledge',
		workflowLabel: 'Knowledge API',
		flowIcon: 'mdi-cloud',
		logIcon: 'mdi-rocket-launch',
		flowColor: 'indigo',
		logColor: '#ff6c37',
		logGradient: 'linear-gradient(135deg, #ff6c37 0%, #ff5722 100%)',
	}),
	products: Object.freeze({
		flowLabel: 'Products',
		workflowLabel: 'Products',
		flowIcon: 'mdi-package-variant',
		flowColor: 'amber',
	}),
	webhook: Object.freeze({
		flowLabel: 'Webhook',
		workflowLabel: 'Webhook',
		flowIcon: 'mdi-webhook',
		flowColor: 'green',
	}),
	email: Object.freeze({
		flowLabel: 'Email',
		workflowLabel: 'Email',
		flowIcon: 'mdi-email',
		flowColor: 'red',
	}),
	sharepoint: Object.freeze({
		flowLabel: 'SharePoint',
		workflowLabel: 'SharePoint',
		flowIcon: 'mdi-microsoft-sharepoint',
		flowColor: 'green',
	}),
	merge: Object.freeze({
		flowLabel: 'Merge',
		logLabel: 'Merge Results',
		workflowLabel: 'Merge',
		flowIcon: 'mdi-call-merge',
		logIcon: 'mdi-merge',
		flowColor: 'blue',
		logColor: '#06b6d4',
		logGradient: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)',
	}),
	interestOptimizer: Object.freeze({
		logLabel: 'Interest Optimizer',
		logIcon: 'mdi-calculator',
		logColor: '#f59e0b',
		logGradient: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
	}),
	loanInterest: Object.freeze({
		logLabel: 'Loan Interest',
		logIcon: 'mdi-home-analytics',
		logColor: '#10b981',
		logGradient: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
	}),
	embedding: Object.freeze({
		logLabel: 'Vector Embedding',
		logIcon: 'mdi-code-array',
		logColor: '#14b8a6',
		logGradient: 'linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)',
	}),
	queryRewriter: Object.freeze({
		flowLabel: 'Query Rewriter',
		flowIcon: 'mdi-message-text-clock-outline',
		flowColor: 'deep-purple',
		logLabel: 'Query Rewriter',
		logIcon: 'mdi-message-text-clock-outline',
		logColor: '#7c3aed',
		logGradient: 'linear-gradient(135deg, #7c3aed 0%, #a855f7 100%)',
	}),
});

function getNodeTypeInfo(nodeType) {
	return NODE_TYPE_INFO[nodeType] || {};
}

export function getJsonConditionOperatorToken(operatorType) {
	return JSON_CONDITION_OPERATOR_TOKENS[operatorType] || '';
}

export function getFlowNodeTypeColor(nodeType) {
	return getNodeTypeInfo(nodeType).flowColor || DEFAULT_FLOW_COLOR;
}

export function getFlowNodeTypeIcon(nodeType) {
	const info = getNodeTypeInfo(nodeType);
	return info.flowIcon || info.logIcon || DEFAULT_ICON;
}

export function getFlowNodeTypeLabel(nodeType) {
	const info = getNodeTypeInfo(nodeType);
	return info.flowLabel || info.workflowLabel || info.logLabel || nodeType;
}

export function getLogNodeName(nodeType) {
	const info = getNodeTypeInfo(nodeType);
	return info.logLabel || info.flowLabel || info.workflowLabel || nodeType;
}

export function getLogNodeIcon(nodeType) {
	const info = getNodeTypeInfo(nodeType);
	return info.logIcon || info.flowIcon || DEFAULT_ICON;
}

export function getLogNodeTypeColor(nodeType) {
	return getNodeTypeInfo(nodeType).logColor || DEFAULT_LOG_COLOR;
}

export function getLogNodeGradient(nodeType) {
	return getNodeTypeInfo(nodeType).logGradient || DEFAULT_LOG_GRADIENT;
}

export function getChatWorkflowLabel(nodeType) {
	if (!nodeType) {
		return '-';
	}

	const info = getNodeTypeInfo(nodeType);
	return info.workflowLabel || info.flowLabel || info.logLabel || nodeType;
}
